import { createFileRoute } from '@tanstack/react-router';
import { FlowEditorSkeleton } from 'src/shared/components/skeletons/FlowEditorSkeleton';

export const Route = createFileRoute('/_authenticated/automations/$flowId')({
  pendingComponent: FlowEditorSkeleton,
});
